// Price conversion utilities
// Official EUR to BGN rate (fixed by Bulgaria's currency board)
const EUR_TO_BGN_RATE = 1.9558;

// Convert EUR to BGN (EURO to LEVA) - това ще е основната конверсия
export const convertEurToBgn = (eurPrice) => {
  return eurPrice * EUR_TO_BGN_RATE;
};

// Convert BGN to EUR (LEVA to EURO) - за обратното, ако трябва
export const convertBgnToEur = (bgnPrice) => {
  return bgnPrice / EUR_TO_BGN_RATE;
};

// Format price with both EUR and BGN (EUR first, then BGN in parentheses)
export const formatDualPrice = (eurPrice) => {
  const bgnPrice = convertEurToBgn(eurPrice);
  return {
    eur: eurPrice.toFixed(2),
    bgn: bgnPrice.toFixed(2)
  };
};

// Get display string for dual price (EUR then BGN in parentheses)
export const getDualPriceString = (eurPrice) => {
  const prices = formatDualPrice(eurPrice);
  return `${prices.eur} € (${prices.bgn} лв.)`;
};

// Get just EUR price string
export const getEurPriceString = (eurPrice) => {
  return `${eurPrice.toFixed(2)} €`;
};

// Get just BGN price string (calculated from EUR)
export const getBgnPriceString = (eurPrice) => {
  const bgnPrice = convertEurToBgn(eurPrice);
  return `${bgnPrice.toFixed(2)} лв.`;
};